'use strict';

angular.module('msCommunity').directive('msComment', [function () {
  return {
    templateUrl: 'community/templates/comment.html',
    restrict: 'E',
    scope: {
      comment: '=commentModel',
      mockupMode: '@',
      showDetailLink: '@',
      updateFunction: '&'
    },
    bindToController: true,
    controller: 'Comment',
    controllerAs: 'comment',
    link: function link(scope, element) {
      if (scope.comment.flag && scope.comment.flag !== 'FAVORITE') {
        element.html = '';
      }
    }
  };
}]).controller('Comment', ['eventTrackingSvc', 'discussionSvc', 'overlaySvc', '$stateParams', function (eventTrackingSvc, discussionSvc, overlaySvc, $stateParams) {
  this.$onInit = function () {
    var vm = this;
    vm.replyId = $stateParams.replyId;
    vm.getNumberComments = numberComments;

    vm.favorite = function () {
      if (vm.comment.flag === 'FAVORITE') {
        // already a favorite - so unflag
        discussionSvc.unflag(vm.comment.id).then(function () {
          vm.comment.flag = null;
        });
        eventTrackingSvc.fireEvent('community', 'toggleFavorite', 'remove', { commentId: vm.comment.id });
      } else {
        discussionSvc.flag(vm.comment.id, 'FAVORITE').then(function () {
          vm.comment.flag = 'FAVORITE';
        });
        eventTrackingSvc.fireEvent('community', 'toggleFavorite', 'add', { commentId: vm.comment.id });
      }
    };

    vm.openFlag = function () {
      overlaySvc.overlay(vm.comment, {
        template: 'discussion-flagging-options'
      }, vm.updateFunction);
    };

    function numberComments(commentList) {
      // Remove flagged comments from each discussion
      return _.filter(commentList, function (comment) {
        return _.isUndefined(comment.flag) || _.isNull(comment.flag) || comment.flag && comment.flag === 'FAVORITE';
      });
    }
  };
}]);